@import '../../../globals/main.scss';
@import '../../navigation/pn-site-footer/pn-site-footer-common.scss';

pn-marketweb-sitefooter {
  .social-media {
    a[target='_blank']:not(.pn-button):after {
      content: none;
    }
  }
}

pn-marketweb-sitefooter:not([theme='dotcom']) {
  @media screen and (min-width: $sitefooter-media-smalldesktop) {
    pn-site-footer-col:has(div[slot='bottomsocialmediadesktop']) {
      display: flex;
      align-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      flex-wrap: wrap;
      min-width: min-content;

      div[slot='bottomsocialmediadesktop'] {
        display: block;
        margin-top: auto;
        margin-bottom: 1.6rem;

        .trustpilot-widget {
          display: flex;
          justify-content: flex-start;
        }
      }
    }
  }

  [slot='bottomsocialmediamobile'] {
    display: block;
    margin-top: 1rem;
    margin-bottom: 2.3rem;

    .trustpilot-widget {
      display: flex;
      justify-content: center;

      @media screen and (min-width: $sitefooter-media-phoneheight) {
        justify-content: flex-start;
      }
    }

    @media screen and (min-width: $sitefooter-media-smalldesktop) {
      display: none;
    }
  }
}

div[slot='middle-extra-mobile'],
div[slot='middle-extra'] {
  display: none;
}

pn-marketweb-sitefooter[theme='dotcom'] {
  width: 100%;

  div[slot='bottomsocialmediamobile'],
  div[slot='bottomsocialmediadesktop'] {
    display: none;
  }

  div[slot='middle-extra-mobile'] {
    display: block;
    width: 100%;
    text-align: -webkit-center;
    margin: 2.4rem 0;
  }

  @media screen and (min-width: 1024px) {
    div[slot='middle-extra-mobile'] {
      display: none;
    }

    div[slot='middle-extra'] {
      display: block;
      width: 100%;
      text-align: -webkit-center;
      margin: 3.2rem 0;
    }
  }

  div[slot='bottom'] .social-media.social-media--swan {
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (min-width: $min-width-md) {
      flex-direction: row;
    }

    ul {
      margin-bottom: 1.6rem;
      @media screen and (min-width: $min-width-md) {
        margin-bottom: 0;
        margin-right: 4.8rem;
      }
    }

    .swan-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;

      @media screen and (min-width: $min-width-md) {
        width: auto;
        flex-direction: row;
      }

      .separator {
        border-top: 1px solid #d3cecb;
        margin-bottom: 1.6rem;

        @media screen and (min-width: $min-width-md) {
          display: flex;
          width: 1px;
          height: auto;
          min-height: 90%;
          background-color: #d3cecb;
          margin-right: 4.8rem;
          margin-bottom: 0;
        }
      }

      .swan {
        justify-self: center;
        align-self: center;
      }
    }
  }

  //com layout in different colors
  &[backgroundcolor='bluedarkest'] pn-site-footer[theme='dotcom'] {
    pn-site-footer-col[theme='dotcom'] svg path {
      fill: $white;
    }

    pn-swan * {
      color: white;
    }
  }

  &[backgroundcolor='blue'] pn-site-footer[theme='dotcom'] {
    background-color: $blue700;

    .pn-sitefooter-top,
    .pn-sitefooter-bottom {
      background-color: $blue700;
    }

    > svg path {
      fill: $blue700;
    }

    .pn-sitefooter-bottom .social-media {
      border-top: 0.1rem solid $gray200;
      border-bottom: 0.1rem solid $gray200;

      & > ul > li:hover svg > circle {
        fill: $blue200;
      }
    }

    pn-site-footer-col[theme='dotcom'] svg path {
      fill: $white;
    }

    pn-swan * {
      color: white;
    }
  }

  &[backgroundcolor='gray'] pn-site-footer[theme='dotcom'] {
    background-color: $gray50;

    > svg path {
      fill: $gray50;
    }

    .pn-sitefooter-top,
    .pn-sitefooter-bottom {
      background-color: $gray50;
    }

    .pn-sitefooter-bottom {
      .social-media {
        border-top: 0.1rem solid $gray200;
        border-bottom: 0.1rem solid $gray200;

        li svg circle {
          fill: $blue700;
        }

        li svg:hover > circle {
          fill: $blue400;
        }
      }

      > [slot='bottom'] > .copyright * {
        color: $blue700;
      }
    }

    pn-site-footer-col[theme='dotcom'] {
      * {
        color: $blue900;
      }

      svg path {
        fill: $blue900;
      }

      a:not(.pn-h2) {
        color: $blue700;
      }
    }
  }
}

pn-marketweb-sitefooter[theme='tpl'] {
  pn-site-footer {
    background-color: $blue900;
    padding-top: 6rem;

    @media screen and (max-width: $sitefooter-media-phoneheight) {
      padding-left: 2.6rem;
      padding-right: 2.6rem;
    }

    & > svg {
      display: none;
    }
  }

  div.pn-sitefooter-bottom {
    background-color: $blue900;
    color: $white;
    margin: 2.5rem 0;

    div[slot='bottom'] {
      border-top: 1px solid $blue700;
      border-bottom: 1px solid $blue700;
    }

    a {
      color: $white;

      &:hover {
        text-decoration: underline;
        color: $white;
      }
    }
  }

  .pn-sitefooter-top,
  .pn-sitefooter-logo {
    background-color: $blue900;
    color: $white;

    a {
      color: $coral200;

      &:hover {
        text-decoration: underline;
        color: $coral200;
      }
    }
  }

  .pn-sitefooter-top .pn-sitefooter-cols {
    @media screen and (max-width: $sitefooter-media-smalldesktop) {
      padding: 0 8rem;
    }

    @media screen and (max-width: $sitefooter-media-smalldesktop) {
      padding: 0 5rem;
    }

    @media screen and (max-width: $sitefooter-media-tablet) {
      padding: 0 3rem;
    }

    @media screen and (min-width: $sitefooter-media-phoneheight) {
      width: 114rem;
      justify-content: space-between;
    }
  }

  div.pn-sitefooter-logo a svg path {
    fill: $blue400;
  }

  div pn-site-footer-col {
    @media screen and (min-width: $sitefooter-media-phoneheight) {
      width: unset;
      min-width: unset;

      &:first-child {
        min-width: 45%;
      }
    }

    &:first-child {
      @media screen and (max-width: $sitefooter-media-smalldesktop) {
        min-width: 100%;
        padding-top: 0;
      }
    }

    a {
      display: inline-flex;
      gap: 0.7rem;
      align-items: flex-start;

      .pn-h2 {
        color: $white;
      }

      span.footer-tpl-links {
        display: none;
      }

      &:hover {
        text-decoration: underline;
        color: $coral200;
      }

      pn-icon svg {
        background-color: $coral200;
        border-radius: 0.3rem;
        height: 1.7rem;
        width: 1.7rem;
        margin-top: 0.3rem;

        path {
          fill: $blue900;
        }
      }
    }

    .pn-h2 {
      margin-bottom: 3.5rem;
    }

    ul.social-media {
      flex-direction: column;
      gap: 0.5rem;
      row-gap: 0rem;

      li {
        max-height: 4rem;
      }

      a {
        align-items: center;
        gap: 0;

        circle {
          display: none;
        }

        span.footer-tpl-links {
          display: block;
        }

        svg {
          height: 3.7rem;
          width: 3.7rem;

          path {
            fill: $coral200;
          }
        }
      }
    }
  }
}
